/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconWifi2 = createReactComponent("wifi-2", "IconWifi2", [
  ["path", { d: "M12 18l.01 0", key: "svg-0" }],
  ["path", { d: "M9.172 15.172a4 4 0 0 1 5.656 0", key: "svg-1" }],
  ["path", { d: "M6.343 12.343a8 8 0 0 1 11.314 0", key: "svg-2" }]
]);

export { IconWifi2 as default };
//# sourceMappingURL=IconWifi2.js.map
